/*    
<summary>
  This functional component "AllGroupsPopup" defines the props like initial values & functions for the child form component.
  Developer:Mohammad Saquib Khan, Created Date: 15 September 2023,
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../../contexts/StoreProvider";
import ChooseGroupForm from "./forms/group/choose-group-form";
import userTypeEnum from "../../../constants/user-type-enum";
import { getUserTypeFromLocalStorage, getTenantIdFromLocalStorage } from "../../../helpers/local-stotrage-helper";
import { formatMessage } from "../../../translations/format-message";

interface IProps {
  allDevices: any[];
  modalClosed: () => void;
}

const AllGroupsSelect = (props: IProps) => {
  const { deviceStore, groupStore, tenantStore } = useStore();
  const { allAvailableGroups, GetAllGroupService } = groupStore;
  const { selectedTenantId } = tenantStore;
  const { addDeviceCSV, addBulkDeviceState, resetAddBulkDeviceState, resetAddDeviceCSV, addDeviceCSVState } =
    deviceStore;

  let t: any;
  const onSubmitForm = (values: any) => {
    addDeviceCSV(values);
  };

  const onModalClosed = () => {
    resetAddDeviceCSV();
    props.modalClosed();
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addBulkDeviceState.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addDeviceCSVState.success) {
      onModalClosed();
    }
  }, [addDeviceCSVState.success]);

    /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addBulkDeviceState.error" of the useEffect changed.
   */
    useEffect(() => {
      if (addDeviceCSVState.error) {
        resetAddDeviceCSV();
      }
    }, [addDeviceCSVState.error]);

  useEffect(() => {
    if(getUserTypeFromLocalStorage() === userTypeEnum.SystemUser)
      GetAllGroupService(selectedTenantId);
    else
      GetAllGroupService(getTenantIdFromLocalStorage());
  }, []);

  return (
    <React.Fragment>
      <Modal
        className="correction-modal fancy-modal"
        show={true}
        centered={false}
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="add_csv_popup" />
          </Modal.Title>
          <button
            onClick={onModalClosed}
            data-testid="Close"
            className="Crossicons"
            title={formatMessage("close")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
        </Modal.Header>
        <div className="p-0">
          <ChooseGroupForm
            initialValues={{ GroupId: -1, CSVFile: "" }}
            groupList={allAvailableGroups}
            submitHandler={onSubmitForm}
            isLoading={addDeviceCSVState.inProgress}
            modalClosed={onModalClosed}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default observer(AllGroupsSelect);
